module.exports = __webpack_public_path__ + "static/media/beschaftigungsgrad-2.27c0db4e.png";